<template>
  <b-row>
    <b-col>
      <tabela-repeticao
        v-model="empresa"
        :somente-visualizacao="true"
        :colunas="colunas"
        class="tabela-historico-inativacao"
      >
        <template #visualizacao="{slotScope: {key,valor}}">
          <b-badge
            v-if="key === 'situacao'"
            :variant="getVarianteSituacao(valor)"
          >
            {{ getDescricaoSituacao(valor) }}
          </b-badge>
          <div
            v-else-if="key === 'competencia'"
            class="ml-50"
          >
            {{ formatarData(valor) }}
          </div>
          <div
            v-else
            class="ml-50"
          >
            {{ valor }}
          </div>
        </template>
      </tabela-repeticao>
    </b-col>
  </b-row>

</template>

<script>
import moment from 'moment'
import colunas from './useColunas'

export default {
  name: 'VisualizacaoHistorico',
  components: {
    TabelaRepeticao: () => import('@pilar/components/tabela-repeticao/TabelaRepeticao.vue'),
  },
  props: {
    empresa: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      colunas,
    }
  },

  methods: {
    visualizarGuia(id, esperar) {
      if (esperar) {
        this.iniciarEspera()
      }
      this.$emit('mostrarGuia', id)
    },
    getDescricaoSituacao(valor) {
      if (valor === 1 || valor === '1') return 'Inativada'
      if (valor === 2 || valor === '2') return 'Reativada'
      return valor // Retorna o valor original se não for 1 ou 2
    },
    getVarianteSituacao(valor) {
      if (valor === 1 || valor === '1') return 'light-danger'
      if (valor === 2 || valor === '2') return 'light-success'
      return 'light-secondary'
    },
    formatarData(data) {
      if (!data) return '-'
      return moment(data).format('DD/MM/YYYY HH:mm:ss')
    },
  },
}

</script>
